import { Moon } from 'lucide-react';
import { useEstadoPlataforma } from '@/lib/queries';

/**
 * La plataforma está apagada: se le dice al comercio antes de que pida.
 *
 * El servidor rechaza igual cualquier envío (`PLATFORM_CLOSED`), pero un
 * rechazo al final del formulario, después de escribir la dirección y el
 * teléfono, se siente como un error. Esto lo dice a la entrada, con el mismo
 * mensaje que ve el cliente en la tienda, y se refresca solo cada minuto:
 * al encender, vuelve a aparecer el botón sin recargar.
 */
export function AvisoPlataformaCerrada() {
  const estado = useEstadoPlataforma();
  if (estado.data?.platformOpen !== false) return null;

  return (
    <div
      role="status"
      className="mt-6 flex items-start gap-4 rounded-kick border border-amber-300 bg-amber-50 p-5"
    >
      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-white text-amber-700">
        <Moon className="h-5 w-5" />
      </span>
      <div>
        <p className="text-lg font-bold text-amber-900">
          En este momento no se está prestando el servicio
        </p>
        <p className="mt-1 text-sm text-amber-900/80">{estado.data.platformClosedMessage}</p>
        <p className="mt-2 text-xs text-amber-900/70">
          Cuando la plataforma vuelva a encenderse, podrás pedir domiciliarios desde aquí.
        </p>
      </div>
    </div>
  );
}

/** ¿Está apagada? Para esconder el botón de pedir sin repetir la consulta. */
export function usePlataformaCerrada(): boolean {
  const estado = useEstadoPlataforma();
  return estado.data?.platformOpen === false;
}
